import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import Logo from "./Logo";
import { CONTACT } from "../lib/constants";

const NAV_ITEMS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/areas", label: "Areas" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className="sticky top-0 z-40 transition-colors"
      style={{
        backgroundColor: scrolled ? "rgba(11,22,35,0.92)" : "rgba(11,22,35,0.6)",
        backdropFilter: "blur(14px)",
        borderBottom: `1px solid ${scrolled ? "var(--hair-strong)" : "var(--hair)"}`,
      }}
    >
      <div className="ve-container flex items-center justify-between py-4">
        <Link to="/" className="flex items-center">
          <Logo size="md" />
        </Link>
        <nav className="hidden lg:flex items-center gap-10">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `text-[0.82rem] tracking-[0.18em] uppercase ve-link-underline ${
                  isActive ? "text-[color:var(--gold-400)]" : ""
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <a href={`tel:${CONTACT.phoneTel}`} className="ve-btn-ghost">
            <Phone size={14} />
            {CONTACT.phoneDisplay}
          </a>
          <a
            href={CONTACT.whatsappLink}
            target="_blank"
            rel="noreferrer"
            className="ve-btn-primary"
          >
            Enquire
          </a>
        </div>
        <button
          className="lg:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          style={{ color: "var(--cream-100)" }}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div
          className="lg:hidden border-t"
          style={{ borderColor: "var(--hair)", background: "var(--ink-800)" }}
        >
          <div className="ve-container py-6 flex flex-col gap-5">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `text-sm tracking-[0.2em] uppercase ${
                    isActive ? "text-[color:var(--gold-400)]" : "text-[color:var(--cream-100)]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <div className="flex flex-col gap-3 pt-4 ve-hair">
              <a href={`tel:${CONTACT.phoneTel}`} className="ve-btn-ghost justify-center">
                <Phone size={14} /> {CONTACT.phoneDisplay}
              </a>
              <a
                href={CONTACT.whatsappLink}
                target="_blank"
                rel="noreferrer"
                className="ve-btn-primary justify-center"
              >
                WhatsApp Enquiry
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;